import * as React from 'react';
import { Bar } from 'react-chartjs-2';
import Chartify from  '@shipsy/chartify';

class DualBarViz extends React.PureComponent<any, any> {

  render() {
    const { formData, chartData } = this.props;
    const chartifyInstance = new Chartify.DualBarData(chartData, formData);
    const chartifyData = chartifyInstance.getManipulatedChartDataAndOptions();

    return (
      <Bar
        data={chartifyData.data.barChartData}
        options={chartifyData.options}
      />
    );
  }
}

export default DualBarViz;
